
import { serialize } from 'object-to-formdata'
import FileUploadInput from '../../inputs/FileUploadInput'
import Setting from '../Setting'
import SettingActions from '../SettingActions'
export default {
    name: 'ProfileImage',
    components: { FileUploadInput, Setting, SettingActions },
    data () {
        return {
            state: 'show',
            modal: null,
            form: new this.$vForm({
                photo: null
            })
        }
    },
    watch: {
        'form.photo' (value) {
            if (value) {
                this.state = 'edit'
            } else {
                this.state = 'show'
            }
        },
        async state (value) {
            if (value === 'show') {
                this.form.photo = null
            }

            if (value === 'submit') {
                try {
                    const { data } = await this.form.submit('post', '/v1/settings/updatePersonalPhoto', {
                        transformRequest: [function (data, headers) {
                            if (typeof data.photo === 'string' || data.photo === null) {
                                delete data.photo
                            }
                            return serialize(data)
                        }]
                    })
                    this.$auth.setUser(data)
                    this.success()
                } catch (e) { this.failed(e) } finally {
                    this.state = 'show'
                }
            }
        }
    },
    methods: {
        success () {
            this.$refs.settings.alert({ type: 'success', body: this.$t('successfully updated') })
        },
        failed (e) {
            if (e.response.status >= 500) {
                this.$refs.settings.alert({
                    type: 'danger',
                    body: this.$t('general error please try again')
                })
            }
        },
        showImg () {
            this.modal = 'img'
        }
    }
}
